var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-store-min-delivery-minutes",
        title: _vm.$t("Tempos de entrega"),
        "no-close-on-backdrop": "",
        centered: "",
        size: "sm",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("e-button", {
                staticClass: "mr-1",
                attrs: {
                  id: "modal-store-min-delivery-minutes-btn_cancel",
                  variant: "outline-primary",
                  text: _vm.$t("Cancelar"),
                },
                on: { click: _vm.hideModal },
              }),
              _c("e-button", {
                attrs: {
                  id: "modal-store-min-delivery-minutes-btn_confirm",
                  variant: "primary",
                  text: _vm.$t("Salvar"),
                  busy: _vm.saving,
                },
                on: { click: _vm.onConfirm },
              }),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "FormulateForm",
        { ref: "form", on: { submit: _vm.onConfirm } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "store-min-delivery-minutes-store",
                      value: _vm.storeName,
                      label: _vm.$tc("STORE.NAME"),
                      type: "label",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "store-min-delivery-minutes-value",
                      name: "minDeliveryScheduleMinutes",
                      type: "number",
                      min: "1",
                      max: "1440",
                      step: "1",
                      validation: "required|number|min:1|max:1440",
                      "validation-messages": {
                        required: _vm.$t(
                          "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                        ),
                        number: _vm.$t(
                          "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                        ),
                        min: _vm.$t(
                          "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                        ),
                        max: _vm.$t(
                          "STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE"
                        ),
                      },
                      label: _vm.$t("Tempo mínimo (min)"),
                      instruction: _vm.$t(
                        "Tempo, em minutos, entre o pedido e a entrega. Valida o agendamento e define a janela do acionamento automático."
                      ),
                    },
                    model: {
                      value: _vm.minutes,
                      callback: function ($$v) {
                        _vm.minutes = _vm._n($$v)
                      },
                      expression: "minutes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "store-lending-installation-minutes-value",
                      name: "lendingInstallationMinutes",
                      type: "number",
                      min: "15",
                      max: "480",
                      step: "5",
                      validation: "required|number|min:15|max:480|multipleOf5",
                      "validation-messages": {
                        required: _vm.$t(
                          "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                        ),
                        number: _vm.$t(
                          "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                        ),
                        min: _vm.$t(
                          "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                        ),
                        max: _vm.$t(
                          "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                        ),
                        multipleOf5: _vm.$t(
                          "STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES"
                        ),
                      },
                      "validation-rules": { multipleOf5: _vm.multipleOf5 },
                      label: _vm.$t("Tempo de instalação do comodato (min)"),
                      instruction: _vm.$t(
                        "Tempo, em minutos, de uma entrega de chope/comodato. Define o tamanho dos horários da agenda de instalação."
                      ),
                    },
                    model: {
                      value: _vm.lendingInstallationMinutes,
                      callback: function ($$v) {
                        _vm.lendingInstallationMinutes = _vm._n($$v)
                      },
                      expression: "lendingInstallationMinutes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }